import React from 'react'

const Success = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M26 12.9938L23.1164 9.54037L23.5182 4.96894L19.2518 3.95031L17.0182 0L13 1.81366L8.98182 0L6.74818 3.95031L2.48182 4.95652L2.88364 9.52795L0 12.9938L2.88364 16.4472L2.48182 21.0311L6.74818 22.0497L8.98182 26L13 24.1739L17.0182 25.9876L19.2518 22.0373L23.5182 21.0186L23.1164 16.4472L26 12.9938ZM10.6364 19.205L5.90909 14.236L7.57545 12.4845L10.6364 15.6894L18.4245 7.50311L20.0909 9.26708L10.6364 19.205Z" fill="currentColor"></path>
</svg>
    )
}

export default Success
